import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Header from '../components/Header';
import NavigationBar from '../components/NavigationBar';
import Icon from '../assets/images/logo/golf-logo.svg';
import AboutGolf from '../components/golf/AboutGolf';
import PerformingGolf from '../components/golf/PerformingGolf';
import Menu from '../components/Menu';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
import { savingNodesPositions } from '../actions/scrolling';
import Contact from '../components/Contact';
import { getDairiesBySlug } from '../actions/DairiesAction';
import { getMenuBySlug } from '../actions/MenusAction';
import { getGallery } from '../actions/GallerieAction';
import HeaderWithBooking from '../components/leqg/HeaderWithBooking';

class Golfbrau extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: [],
      images: [],
      items: [],
      dairies: [],
    };
  }

  componentDidMount() {
    this.props.getGallery('golfbrausousse');
    this.props.getMenuBySlug('golfbrausousse');
    this.props.getDairiesBySlug('golfbrausousse', 'golfbrauhammamet');

    const about = ReactDOM.findDOMNode(this.refs.about);
    const performing = ReactDOM.findDOMNode(this.refs.performing);
    const menu = ReactDOM.findDOMNode(this.refs.menu);
    const gallery = ReactDOM.findDOMNode(this.refs.gallery);

    this.props.savingNodesPositions({
      golfbrau: {
        about: about.offsetTop,
        performing: performing.offsetTop,
        menu: menu.offsetTop,
        gallery: gallery.offsetTop,
      },
    });
  }

  render() {
    return (
      <Fragment>
        <Header
          content={
            <HeaderWithBooking
              icon={
                <div className="container">
                  <div className="row pt-5 pb-5">
                    <div className="col-md-4 offset-md-4 col-xs-8 offset-xs-2">
                      <img alt="Logo" className="golf-header-logo" src={Icon} />
                    </div>
                    <div className="col-md-4 offset-md-4 col-xs-8 offset-xs-2 mt-3">
                      <h5 className="sub-cover">El Kantaoui - Hammamet</h5>
                    </div>
                  </div>
                </div>
              }
              eventsBooking={this.props.events}
            />
          }
          background="golf-header-bg"
        >
          <NavigationBar
            slug="golfbrau"
            navigations={[
              { name: 'about', txt: 'About' },
              { name: 'performing', txt: 'Performing' },
              { name: 'menu', txt: 'Menus' },
              { name: 'gallery', txt: 'Gallery' },
            ]}
          />
        </Header>
        <AboutGolf ref="about" background="golf-about-bg" />
        <PerformingGolf ref="performing" data={this.props.dairy} />
        <Menu ref="menu" background="golf-menu-bg" color="red" data={this.props.menus} />
        <Gallery ref="gallery" background="golf-gallery-bg" medias={this.props.gallerie} />
        <Contact ref="contact" minimal color="#ef2744" palceholders="#c02234" background="golf-contact-bg" info={info} />
        <Footer color="#ef2744" secondColor="#c02234" />
      </Fragment>
    );
  }
}

const info = {
  facebook: 'https://www.facebook.com/GBRAUSousse/',
  insta: 'https://www.instagram.com/golfbraukantaoui/',
  youtube: '',
  tripAdvisor:
    'https://www.tripadvisor.fr/Restaurant_Review-g297952-d6778391-Reviews-Golf_Brau-Port_El_Kantaoui_Sousse_Governorate.html',
  address: <span>SOCIETE " G A S " SARL 6ET, IMM "VENUS" A 6-4, Golf Advanced Services, 1082 CENTRE URB NORD</span>,
};

export default connect(
  store => ({
    scrolling: store.scrolling,
    menus: store.menus,
    gallerie: store.gallerie,
    dairy: store.dairy,
  }),
  {
    savingNodesPositions,
    getMenuBySlug,
    getGallery,
    getDairiesBySlug,
  }
)(Golfbrau);



// WEBPACK FOOTER //
// ./src/pages/golfbrau.jsx